import { useQueryClient } from 'react-query';

import { AppMessage } from '@/common/components';
import { useAppSocket } from '@/common/hooks';
import { AppRoutes } from '@/common/interfaces';

import { SearchConsoleAccountsGatewayKeys, SearchConsoleAccountsQueryKeys } from '@/modules/DomainsApi';

import { useNavigate } from 'react-router';

interface Data {
  accountId: string;
  success: boolean;
  message?: string;
}

interface Args {
  searchConsoleAccountId: string;
  searchConsoleAccountUrlRequestSuccess: boolean;
  queryClient: ReturnType<typeof useQueryClient>;
  navigate: ReturnType<typeof useNavigate>;
}

export const useUpdateTokenStatus = ({
  searchConsoleAccountId,
  searchConsoleAccountUrlRequestSuccess,
  queryClient,
  navigate,
}: Args): void => {
  const appMessageApi = AppMessage.useControls();

  useAppSocket<Data>(SearchConsoleAccountsGatewayKeys.UpdateTokenStatus, async ({ lastMessage }) => {
    const { accountId, success, message } = lastMessage;

    if (searchConsoleAccountId && searchConsoleAccountUrlRequestSuccess && accountId === searchConsoleAccountId) {
      if (success) {
        navigate(AppRoutes.DomainsApiSearchConsoleAccountsById.replace(':searchConsoleAccountId', accountId));

        await queryClient.refetchQueries([SearchConsoleAccountsQueryKeys.GetAll], { exact: false });
      } else {
        appMessageApi.error(message);
      }
    }
  });
};
